<section class="recruiter-testimonials" id="testimonials" (mouseenter)="stopAutoPlay()" (mouseleave)="startAutoPlay()">
  <div class="recruiter-testimonials__container">
    <div class="recruiter-testimonials__header">
      <div class="recruiter-testimonials__badge">TRUSTED BY TEAMS</div>
      <h2 class="recruiter-testimonials__title">
        What recruiters <span class="recruiter-testimonials__title-highlight">say</span>
      </h2>
      <p class="recruiter-testimonials__subtitle">Hiring teams at leading enterprises trust BeExpert to hire faster and smarter.</p>
    </div>
    
    <div class="recruiter-testimonials__slider">
      <div class="recruiter-testimonials__track" [style.transform]="'translateX(calc(-' + currentIndex + ' * (100% / ' + itemsToShow + ' + 1.5rem / ' + itemsToShow + ')))'">
        @for (testimonial of testimonials; track testimonial.author) {
          <div class="recruiter-testimonials__card">
            
            <!-- Quote Icon & Company Logo -->
            <div class="recruiter-testimonials__card-top">
              <svg class="recruiter-testimonials__quote-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <!-- '9' shape left -->
                <path d="M10 11c0 3-3 7-5 7a4 4 0 1 1 3-6.5V11z"></path>
                <!-- '9' shape right -->
                <path d="M20 11c0 3-3 7-5 7a4 4 0 1 1 3-6.5V11z"></path>
              </svg>
              <div class="recruiter-testimonials__logo">
                @switch (testimonial.company) {
                  @case ('TCS') {
                    <svg viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
                  }
                  @case ('Infosys') {
                    <div class="logo-infosys-badge">Info</div>
                  }
                  @case ('Microsoft') {
                    <svg viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path fill="#f25022" d="M1 1h10.5v10.5H1z"/><path fill="#7fba00" d="M12.5 1H23v10.5H12.5z"/><path fill="#00a4ef" d="M1 12.5h10.5V23H1z"/><path fill="#ffb900" d="M12.5 12.5H23V23H12.5z"/></svg>
                  }
                  @case ('Amazon') {
                    <div class="logo-amazon-text">amazon</div>
                  }
                  @case ('Google') {
                    <svg viewBox="0 0 24 24" width="20" height="20" xmlns="http://www.w3.org/2000/svg"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
                  }
                }
              </div>
            </div>
            
            <!-- Testimonial Quote -->
            <p class="recruiter-testimonials__quote-text">"{{ testimonial.quote }}"</p>
            
            <!-- Stars -->
            <div class="recruiter-testimonials__stars">
              @for (star of [1,2,3,4,5]; track star) {
                <svg viewBox="0 0 20 20">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
              }
            </div>
            
            <!-- Dashed Divider -->
            <div class="recruiter-testimonials__divider"></div>
            
            <!-- Author Info -->
            <div class="recruiter-testimonials__author">
              <img [src]="testimonial.avatarUrl" [alt]="testimonial.author" class="recruiter-testimonials__avatar" />
              <div>
                <h4 class="recruiter-testimonials__name">{{ testimonial.author }}</h4>
                <p class="recruiter-testimonials__role">{{ testimonial.role }} - {{ testimonial.company }}</p>
              </div>
            </div>
            
          </div>
        }
      </div>
    </div>

    <!-- Navigation Controls -->
    <div class="recruiter-testimonials__controls">
      <button class="recruiter-testimonials__btn-arrow" aria-label="Previous" (click)="prev()" [disabled]="currentIndex === 0" [style.opacity]="currentIndex === 0 ? '0.5' : '1'">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
      </button>
      <button class="recruiter-testimonials__btn-arrow" aria-label="Next" (click)="next()" [disabled]="currentIndex >= testimonials.length - itemsToShow" [style.opacity]="currentIndex >= testimonials.length - itemsToShow ? '0.5' : '1'">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <line x1="5" y1="12" x2="19" y2="12"></line>
          <polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </button>
    </div>
  </div>
</section>
